//#region ../erd-editor-schema/dist/utils/bit.js
function bHas(bit, value) {
	return (bit & value) === value;
}
//#endregion
export { bHas };
